import { useState } from "react";
import { ChevronDown, HelpCircle } from "lucide-react";
import { FAQS } from "@/data/faqs";

export default function FAQSection() {
  const [open, setOpen] = useState(0);

  return (
    <section
      id="preguntas-frecuentes"
      aria-labelledby="faq-heading"
      className="px-6 py-20 sm:py-24 bg-white border-t border-slate-100"
      data-testid="home-faq-section"
    >
      <div className="max-w-3xl mx-auto">
        <div className="text-center mb-12">
          <span className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-[#1E3A8A]/10 text-[#1E3A8A] text-xs font-semibold uppercase tracking-wide">
            <HelpCircle className="w-3.5 h-3.5" />
            Preguntas frecuentes
          </span>
          <h2
            id="faq-heading"
            className="mt-4 font-display text-3xl sm:text-4xl font-bold tracking-tight text-slate-900"
          >
            Todo lo que necesitas saber sobre la Ley 21.719
          </h2>
          <p className="mt-4 text-base text-slate-600 leading-relaxed max-w-2xl mx-auto">
            Respuestas claras a las dudas más comunes sobre la nueva Ley de
            Protección de Datos Personales en Chile, vigente desde el{" "}
            <strong>1 de diciembre de 2026</strong>.
          </p>
        </div>

        {/* SEO-friendly: questions/answers always rendered in DOM via <details>.
            JS controls only the visual accordion state. */}
        <div className="space-y-3" data-testid="home-faq-list" itemScope itemType="https://schema.org/FAQPage">
          {FAQS.map((f, i) => {
            const isOpen = open === i;
            return (
              <article
                key={i}
                className="bg-white border border-slate-200 rounded-xl overflow-hidden"
                data-testid={`home-faq-item-${i}`}
                itemScope
                itemProp="mainEntity"
                itemType="https://schema.org/Question"
              >
                <button
                  type="button"
                  onClick={() => setOpen(isOpen ? -1 : i)}
                  className="w-full flex items-center justify-between gap-4 p-5 sm:p-6 text-left hover:bg-slate-50/50 transition-colors"
                  data-testid={`home-faq-toggle-${i}`}
                  aria-expanded={isOpen}
                  aria-controls={`home-faq-panel-${i}`}
                >
                  <h3 itemProp="name" className="font-display text-base sm:text-lg font-semibold text-slate-900 leading-snug">
                    {f.q}
                  </h3>
                  <ChevronDown
                    className={`w-5 h-5 text-slate-400 shrink-0 transition-transform ${
                      isOpen ? "rotate-180" : ""
                    }`}
                    aria-hidden="true"
                  />
                </button>
                <div
                  id={`home-faq-panel-${i}`}
                  className={`px-5 sm:px-6 ${isOpen ? "pb-5 sm:pb-6 -mt-1 block" : "hidden"}`}
                  itemScope
                  itemProp="acceptedAnswer"
                  itemType="https://schema.org/Answer"
                >
                  <p itemProp="text" className="text-slate-600 leading-relaxed">
                    {f.a}
                  </p>
                </div>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
}
